import React from "react";
import {
  Page,
  TextContainer,
  Card,
  Layout,
  FormLayout,
  SkeletonBodyText,
  SkeletonDisplayText,
  Spinner,
} from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";

export default function LocationFormSkeleton(props) {
  return (
    <div className="locationForm">
      <Page>
        <TitleBar
          title=" "
          breadcrumbs={[{ content: "Locations", url: "/places/locations" }]}
        />
        <Layout>
          <Layout.Section>
            <Card>
              <Card.Section>
                <TextContainer>
                  <SkeletonDisplayText />
                  <SkeletonBodyText lines={1} />
                </TextContainer>
              </Card.Section>
              <Card.Section>
                <FormLayout>
                  <SkeletonDisplayText />
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                  <FormLayout.Group>
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              <Card.Section>
                <FormLayout>
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                </FormLayout>
              </Card.Section>
              <Card.Section>
                <FormLayout>
                  <SkeletonDisplayText />
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                </FormLayout>
              </Card.Section>
            </Card>
          </Layout.Section>

          <Layout.Section secondary>
            <Card>
              <Card.Section>
                <div
                  style={{
                    height: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner size="large" />
                </div>
              </Card.Section>
            </Card>
            <Card sectioned>
              <TextContainer>
                <SkeletonDisplayText />
                <SkeletonBodyText lines={4} />
              </TextContainer>
            </Card>
            <Card sectioned>
              <FormLayout>
                <SkeletonDisplayText />
                <SkeletonBodyText lines={2} />
              </FormLayout>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    </div>
  );
}
